import type { SnipcartProduct } from "@/lib/storefront-types";

type AddToCartButtonProps = {
  product: Pick<SnipcartProduct, "buttonAttributes">;
  label?: string;
  onBeforeAddToCart?: () => void;
  size?: "default" | "compact" | "category" | "hero";
};

export function AddToCartButton({
  product,
  label,
  onBeforeAddToCart,
  size = "default",
}: AddToCartButtonProps) {
  // Casing + weight live per-size: every size is uppercase except the
  // detail-page `hero`, which is title-case to match its design.
  const sizeClass =
    size === "compact"
      ? "px-4 py-2.5 text-xs font-semibold uppercase"
      : size === "category"
        ? "w-full px-6 py-3.5 text-sm font-semibold uppercase sm:w-[86%] sm:max-w-[20rem] sm:py-4 sm:text-[0.98rem]"
        : size === "hero"
          ? "px-[38px] py-[18px] text-base font-bold shadow-[0_22px_40px_-18px_rgba(0,0,0,0.6)]"
          : "px-5 py-3 text-sm font-semibold uppercase";
  const buttonLabel = label?.trim() || "Add to cart";

  return (
    <button
      type="button"
      onClick={onBeforeAddToCart}
      className={`snipcart-add-item inline-flex items-center justify-center gap-2.5 rounded-full storefront-bg-primary text-white transition-[background-color,color,box-shadow,transform] duration-200 hover:-translate-y-px hover-storefront-bg-primary-dark ${sizeClass}`}
      {...product.buttonAttributes}
    >
      {buttonLabel}
    </button>
  );
}
